import ApiService from '../apiservice'

export default class RelatorioProcessoService extends ApiService {
  constructor() {
    super('/relatorioProcesso')
  }

  relatorioProcesso(filtro) {
    let params = `?empresa=${filtro.empresa}&usuario=${filtro.usuario}`
    
    //Filtra por pessoas
    params = `${params}&pessoa=${filtro.pessoa}`;
 
    //Grupo de Trabalho
    params = `${params}&grupoTrabalho=${filtro.grupoTrabalho}`;

    //Tipo de Ação
    params = `${params}&tipoAcao=${filtro.tipoAcao}`;
    
    //Área de Atuação
    params = `${params}&areaAtuacao=${filtro.areaAtuacao}`
 
    //Tipo de Decisão
    params = `${params}&tipoDecisao=${filtro.tipoDecisao}`;
 
    //Data de Decisão
    params = `${params}&dataDecisaoInicial=${filtro.dataDecisaoInicial}&dataDecisaoFinal=${filtro.dataDecisaoFinal}`;

    //Data de Distribuição
    params = `${params}&dataDistribuicaoInicial=${filtro.dataDistribuicaoInicial}&dataDistribuicaoFinal=${filtro.dataDistribuicaoFinal}`;
 
    //Status Processual
    params = `${params}&statusProcessual=${filtro.statusProcessual}`;
 
    // Exceto processos arquivados
    params = `${params}&excetoArquivados=${filtro.excetoArquivados}`;
 
    //Data de Sentença
    params = `${params}&dataSentencaInicial=${filtro.dataSentencaInicial}&dataSentencaFinal=${filtro.dataSentencaFinal}`;
 
    //Objetos de Ação
    params = `${params}&objetoAcao=${filtro.objetoAcao}`;
 
    //Garantias
    params = `${params}&garantia=${filtro.garantia}`;
 
    //Operador Lógico das garantias
    params = `${params}&operadorLogicoGarantia=${filtro.operadorLogicoGarantia}`;
 
    //Valor Garantias
    params = `${params}&valorGarantia=${filtro.valorGarantia}`;
 
    //Pagamentos
    params = `${params}&pagamento=${filtro.pagamento}`;
 
    //Operador Lógico de Pagamentos
    params = `${params}&operadorLogicoPagamento=${filtro.operadorLogicoPagamento}`;
 
    //Valor Pagamento
    params = `${params}&valorPagamento=${filtro.valorPagamento}`;
 
    //Custas
    params = `${params}&custas=${filtro.custas}`;
 
    //Operador Lógico das Custas
    params = `${params}&operadorLogicoCustas=${filtro.operadorLogicoCustas}`;
 
    //Valor das custas
    params = `${params}&valorCustas=${filtro.valorCustas}`;
 
    //Data de Cadastro do processo
    params = `${params}&dataCadastroInicial=${filtro.dataCadastroInicial}&dataCadastroFinal=${filtro.dataCadastroFinal}`;
 
    //Data de Alteração
    params = `${params}&dataAlteracaoInicial=${filtro.dataAlteracaoInicial}&dataAlteracaoFinal=${filtro.dataAlteracaoFinal}`;
 
    //Importante paa Empresa
    params = `${params}&importanteEmpresa=${filtro.importanteEmpresa}`;

    //Importante para Mim
    params = `${params}&importanteParaMim=${filtro.importanteParaMim}`;

    //Estratégico
    params = `${params}&estrategico=${filtro.estrategico}`;

    //Responsável
    params = `${params}&responsavel=${filtro.responsavel}`;

    //Bancada
    params = `${params}&banca=${filtro.banca}`;

    //Pedidos
    params = `${params}&pedidos=${filtro.pedidos}`;

    //Rito
    params = `${params}&rito=${filtro.rito}`;

    //Motivo Resultado
    params = `${params}&motivoResultado=${filtro.motivoResultado}`;

    //UF
    params = `${params}&uf=${filtro.uf}`;
   
    //Data de Arquivamento
    params = `${params}&dtArquivamentoInicial=${filtro.dataArquivamentoInicial}&dtArquivamentoFinal=${filtro.dataArquivamentoFinal}`;
 
    return this.get(params);
  }

  exportarRelatorio(relatorioProcesso) {
    return this.post('/exportar',relatorioProcesso);
  }

  listarRelatoriosExportados(usuario) {
    return this.get(`/relatoriosExportados/${usuario}`);
  }

  excluirRelatorio(relatorio, usuario) {
    return this.delete(`/excluirRelatorio?relatorio=${relatorio}&usuario=${usuario}`);
  }

  consultarRelatorio(codigo) {
    return this.get(`/consultarRelatorio/${codigo}`);
  }

  download(codigo) {
    return this.get2(`/download/${codigo}`);
  }
}